
/**
 * The service for displaying alerts
 * @param {} constants 
 * @returns {} 
 */
export default function () {

    var alerts = [];

    /**
     * Push an alert object into the current alert stack
     * @param {} type 
     * @param {} prefix 
     * @param {} text 
     * @returns {} 
     */
    function add(type, prefix, msg) {
        alerts.push({
            type: type,
            prefix: prefix,
            msg: msg,
            close: () => alerts.splice(0, 1)
        });
    }

    return {
        add: add,
        get: () => alerts
    }
};